import React from 'react';
import styles from './componentCss/TrustedBySection.module.css';
import { useTranslation } from 'react-i18next';

const clientLogos = [
    {
        src: `${process.env.PUBLIC_URL}/img/ProjectImages/GSK_Icon.png`,
        alt: 'GSK',
        width: '110px',
        height: 'auto'
    },
    {
        src: `${process.env.PUBLIC_URL}/img/ProjectImages/Logo_RTE.png`,
        alt: 'RTE',
        width: '120px',
        height: 'auto'
    },
    {
        src: `${process.env.PUBLIC_URL}/img/ProjectImages/Logo_Total.png`,
        alt: 'Total',
        width: '120px',
        height: 'auto'
    },
    {
        src: `${process.env.PUBLIC_URL}/img/ProjectImages/Onet_Icon.png`,
        alt: 'Onet',
        width: '120px',
        height: 'auto'
    },
    {
        src: `${process.env.PUBLIC_URL}/img/ProjectImages/Ferring_Icon.png`,
        alt: 'Ferring',
        width: '120px',
        height: 'auto'
    },
    {
        src: `${process.env.PUBLIC_URL}/img/ProjectImages/Logo_biotech.png`,
        alt: 'Ferring',
        width: '120px',
        height: 'auto'
    },
    {
        src: `${process.env.PUBLIC_URL}/img/ProjectImages/Logo_Enedis.png`,
        alt: 'Enedis',
        width: '120px',
        height: 'auto'
    }
];

const TrustedBySection = () => {
    const { t } = useTranslation();

    return (
        <section className={styles.trustedSection}>
            <h2 className={styles.sectionTitle}>{t('TrustedBy.Title')}</h2>
            <div className={styles.sectionBar}></div>
            <div className={styles.logoGrid}>
                {clientLogos.map((logo, index) => (
                    <img
                        key={index}
                        src={logo.src}
                        alt={logo.alt}
                        style={{ width: logo.width, height: logo.height }}
                        className={styles.logo}
                        loading="lazy"
                    />
                ))}
            </div>
        </section>
    );
};

export default TrustedBySection;
